module.exports = __webpack_public_path__ + "static/media/sacramento-mobile.6b87438b.png";